// Student Evaluation page (redesign): server state for the student's header, audit programs, audit tree and What-If.
// Staged audit edits are UI state and live in the page's useStagedAudit reducer, not here.
export const STUDENT_AUDIT_OPEN = 'STUDENT_AUDIT_OPEN';
export const STUDENT_AUDIT_CLOSE = 'STUDENT_AUDIT_CLOSE';

export const STUDENT_AUDIT_HEADER_SUCCESS = 'STUDENT_AUDIT_HEADER_SUCCESS';
export const STUDENT_AUDIT_HEADER_ERROR = 'STUDENT_AUDIT_HEADER_ERROR';
export const STUDENT_AUDIT_PHOTO_SUCCESS = 'STUDENT_AUDIT_PHOTO_SUCCESS';

export const STUDENT_AUDIT_PROGRAMS_REQUEST = 'STUDENT_AUDIT_PROGRAMS_REQUEST';
export const STUDENT_AUDIT_PROGRAMS_SUCCESS = 'STUDENT_AUDIT_PROGRAMS_SUCCESS';
export const STUDENT_AUDIT_PROGRAMS_ERROR = 'STUDENT_AUDIT_PROGRAMS_ERROR';

export const STUDENT_AUDIT_SELECT_PROGRAM = 'STUDENT_AUDIT_SELECT_PROGRAM';

export const STUDENT_AUDIT_TREE_REQUEST = 'STUDENT_AUDIT_TREE_REQUEST';
export const STUDENT_AUDIT_TREE_SUCCESS = 'STUDENT_AUDIT_TREE_SUCCESS';
export const STUDENT_AUDIT_TREE_ERROR = 'STUDENT_AUDIT_TREE_ERROR';

export const STUDENT_AUDIT_WHAT_IF_REQUEST = 'STUDENT_AUDIT_WHAT_IF_REQUEST';
export const STUDENT_AUDIT_WHAT_IF_SUCCESS = 'STUDENT_AUDIT_WHAT_IF_SUCCESS';
export const STUDENT_AUDIT_WHAT_IF_ERROR = 'STUDENT_AUDIT_WHAT_IF_ERROR';
export const STUDENT_AUDIT_WHAT_IF_EXIT = 'STUDENT_AUDIT_WHAT_IF_EXIT';
